import { ITagResult } from '../../../../../../httpClient/serverApi/types/IResponse';
import { IAnalyticsExtSiteSettings } from '../../../../../../settings/types/ISiteSettingsForSiteAdmin';
import { TagRequest } from '../../../TagRequest';

export type IUpdateAnalyticsExtSiteSettingsResult = ITagResult & IAnalyticsExtSiteSettings;

export class UpdateAnalyticsExtSiteSettingsRequest extends TagRequest<IAnalyticsExtSiteSettings, IUpdateAnalyticsExtSiteSettingsResult> {
  constructor(params: IAnalyticsExtSiteSettings) {
    super('analyticsextensions', 'updateAnalyticsExtensionsSiteSettings', params);
  }
}
